import _sfc_main from "./component-library146.mjs";
import "./component-library147.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { directives: [{ name: "touch", rawName: "v-touch:swipe.left", value: () => {
    _vm.changeSlide(1);
  }, expression: "\n    () => {\n      changeSlide(1);\n    }\n  ", arg: "swipe", modifiers: { "left": true } }, { name: "touch", rawName: "v-touch:swipe.right", value: () => {
    _vm.changeSlide(-1);
  }, expression: "\n    () => {\n      changeSlide(-1);\n    }\n  ", arg: "swipe", modifiers: { "right": true } }], staticClass: "slider", class: _vm.sliderClass, style: _vm.sliderStyles, on: { "mouseenter": _vm.hoverEnter, "mouseleave": _vm.hoverLeave } }, [_vm.slideCount > 1 && _vm.autoplay > 0 ? [_c("PlayPauseButton", { attrs: { "aria-label": _vm.isPlaying ? "Slider pausieren" : "Slider abspielen" }, model: { value: _vm.isPlaying, callback: function($$v) {
    _vm.isPlaying = $$v;
  }, expression: "isPlaying" } })] : _vm._e(), _vm._t("arrows", function() {
    return [_vm.slideCount > 1 ? [_c("Arrow", { staticClass: "slider__arrow slider__arrow--left", attrs: { "set-position": "", "direction": "left", "aria-label": "Vorheriges Slide" }, on: { "change": function($event) {
      return _vm.changeSlide(-1);
    } } }), _c("Arrow", { staticClass: "slider__arrow slider__arrow--right", attrs: { "set-position": "", "direction": "right", "aria-label": "Nächstes Slide" }, on: { "change": function($event) {
      return _vm.changeSlide(1);
    } } })] : _vm._e()];
  }), _c("div", { ref: "sliderContent", staticClass: "slider__content" }, [_vm._t("default", null, { "activeSliderIndex": _vm.activeSliderIndex })], 2), _vm.slideCount > 1 ? [_vm._t("pagination", function() {
    return [_c("DotPagination", { staticClass: "slider__pagination", attrs: { "pages": _vm.pages, "prefix": "Teaser" }, on: { "update": _vm.selectSlide } })];
  })] : _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "d04e3117",
  null,
  null
);
const slider = __component__.exports;
export {
  slider as default
};
